import React, { memo, useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";

const ContentComponent = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  user_roles,
  staffList = [],
  values,
  setting,
  onChange,
}) => {
  const [showNewStaffInput, setShowNewStaffInput] = useState(false);

  // Reset khi modal đóng
  useEffect(() => {
    if (!isOpen) {
      setShowNewStaffInput(false);
    }
  }, [isOpen]);

  const staffOptions = [
    { value: "new", label: "+ Tạo nhân viên mới", isCreateNew: true },
    ...staffList,
  ];

  const handleStaffChange = (selectedOption) => {
    if (selectedOption && selectedOption.value === "new") {
      setShowNewStaffInput(true);
      onChange(selectedOption, "staff_id");
      onChange("", "newStaffName");
      onChange("", "name");
    } else {
      setShowNewStaffInput(false);
      onChange(selectedOption, "staff_id");
      if (selectedOption) {
        onChange(selectedOption.name || selectedOption.label, "name");
      } else {
        onChange("", "name");
        onChange("", "newStaffName");
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      wrapClassName="modal-right"
      backdrop={true}
      autoFocus={false}
    >
      <Form onSubmit={(e) => onSubmit(e)}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody className="scrool modal-right-add">
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            id="modal-right__body"
          >
            {/* Staff Selection */}
            <FormGroup>
              <Label for="staff_id" className="text-muted">
                <IntlMessages id="user-role.name" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="staff_id"
                value={values.staff_id}
                isDisabled={setting.viewonly && !setting.add}
                placeholder="Chọn nhân viên hoặc tạo mới"
                options={staffOptions}
                onChange={handleStaffChange}
                isClearable
                formatOptionLabel={(option) => (
                  <div
                    style={{
                      color: option.isCreateNew ? "#28a745" : "inherit",
                      fontWeight: option.isCreateNew ? "bold" : "normal",
                    }}
                  >
                    {option.label}
                  </div>
                )}
              />
            </FormGroup>

            {/* Chỉ hiện khi chọn "Tạo nhân viên mới" */}
            {showNewStaffInput && (
              <FormGroup>
                <Label for="newStaffName" className="text-muted">
                  Tên nhân viên mới<span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="newStaffName"
                  id="newStaffName"
                  placeholder="Nhập tên nhân viên mới"
                  disabled={setting.viewonly && !setting.add}
                  value={values.newStaffName || ""}
                  onChange={onChange}
                />
              </FormGroup>
            )}

            <FormGroup>
              <Label for="username" className="text-muted">
                <IntlMessages id="profile.username" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="text"
                name="username"
                id="username"
                disabled={setting.viewonly && !setting.add}
                value={values.username}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email" className="text-muted">
                <IntlMessages id="email" />
              </Label>
              <Input
                type="text"
                name="email"
                id="email"
                disabled={setting.viewonly && !setting.add}
                value={values.email}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="password" className="text-muted">
                <IntlMessages id="user.password" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="password"
                name="password"
                id="password"
                placeholder={setting.add ? "" : "Để trống nếu không thay đổi"}
                disabled={setting.viewonly && !setting.add}
                value={values.password}
                onChange={onChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="repassword" className="text-muted">
                <IntlMessages id="user.re-password" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="password"
                name="repassword"
                id="repassword"
                placeholder={setting.add ? "" : "Để trống nếu không thay đổi"}
                disabled={setting.viewonly && !setting.add}
                value={values.repassword}
                onChange={onChange}
              />
            </FormGroup>

            <FormGroup>
              <Label for="user_role_id" className="text-muted">
                <IntlMessages id="role.title" />
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                name="user_role_id"
                value={values.user_role_id}
                isDisabled={setting.viewonly && !setting.add}
                placeholder={<IntlMessages id="user-role.select-one" />}
                options={user_roles}
                onChange={(e) => {
                  onChange(e, "user_role_id");
                }}
              />
            </FormGroup>
          </PerfectScrollbar>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            <IntlMessages id="user-role.btn-add" />
          </Button>{" "}
          <Button color="secondary" type="button" onClick={toggle}>
            <IntlMessages id="general.btn-cancel" />
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default memo(ContentComponent);
